<div class="card kpi-yellow">
    <div class="card-body kpi-card">
        <h5 class="card-title">
            Évolution sur 10 ans
        </h5>
        <p class="card-value">
            <ng-container *ngIf="preview || favorite.ad_city.evol_prix_ville.evol_10y == ''">- %</ng-container>
            <ng-container *ngIf="!preview && favorite.ad_city.evol_prix_ville.evol_10y != ''">
                {{  toFloat(favorite.ad_city.evol_prix_ville.evol_10y) * 100 | number: '1.1-1' }} %
            </ng-container>
        </p>
    </div>
</div>

